import React from 'react'

import UserUpdate from '../Integration/UserUpdate'
import Header from '../Integration/Header'

function  PageUserUpdate() {
  return (
    <div>

        <Header/>
       <UserUpdate/>
        
        </div>
  )
}

export default PageUserUpdate